import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { scanService } from 'src/services/scan.service'
import { IScanUpdateStatusDto } from 'src/types'

export const useUpdateScanStatus = (invalidateQuery: boolean = false) => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation((dto: IScanUpdateStatusDto) => scanService.updateScanStatus(dto), {
    onSuccess(data) {
      if (!data) return

      if (invalidateQuery) {
        queryClient.invalidateQueries(QUERY_KEYS.SCANS)
      }

      queryClient.invalidateQueries(QUERY_KEYS.SCANS_STATUS_COUNT)

      queryClient.invalidateQueries([QUERY_KEYS.SCANS_UNREVIEWED_COUNT, accountId || ''])
    },
  })
}
